export var DEFAULT_TIMEOUT = 60000;